'use client';

import ChatHeader from './ChatHeader';
import ChatIntro from './ChatIntro';
import QuickSuggestions from './QuickSuggestions';
import ChatInput from './ChatInput';
import { useChat } from '../context/ChatContext';
import '../styles/animations.css';
import ChatMessages from './ChatMessages';

export default function ChatContainer() {
  const { isOpen, messages, isStreaming, isPropertyDetail } = useChat();

  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      {(isStreaming || isPropertyDetail) && (
        <div className="streaming-overlay pointer-events-none absolute inset-0" />
      )}
      {/* Backdrop */}
      {/* <div className="absolute inset-0 bg-black/20" /> */}

      <div className="fixed inset-x-0 bottom-6 flex justify-center">
        <div className={`chat-shell ${isOpen ? 'chat--open' : ''}`}>
          <div
            className="pointer-events-none absolute -inset-1 rounded-[24px]
            bg-[linear-gradient(135deg,rgba(0,108,255,0.2),rgba(247,31,248,0.2))]
            blur-xl"
          />

          <div className="relative z-10  flex h-[482px] w-[487px] flex-col rounded-[24px] bg-white shadow-xl overflow-hidden">
            <ChatHeader />
            {messages.length !== 0 && (
              <hr className="m-0 -mx-[24px] border-t border-gray-200" />
            )}

            <div className="flex-1  overflow-y-auto scrollbar-hide">
              {messages.length === 0 ? <ChatIntro /> : <ChatMessages />}
            </div>

            <div className="">
              {messages.length === 0 && <QuickSuggestions />}
            </div>

            <ChatInput />
          </div>
        </div>
      </div>
    </div>
  );
}
